import {
  Route,
  createBrowserRouter,
  createMemoryRouter,
  createRoutesFromElements,
} from 'react-router-dom'
import { IS_ON_IFRAME } from '@stlm/common-ui/lib'

import { App } from '../App'
import { ROUTES } from '../constants/routes'
import { MainPage } from '../pages/main/MainPage'

const routes = (
  <Route element={<App />}>
    <Route
      path={ROUTES.HOME}
      element={<MainPage isPlatform={IS_ON_IFRAME} />}
    />
  </Route>
)

const createRouter = IS_ON_IFRAME ? createMemoryRouter : createBrowserRouter

export const router = createRouter(createRoutesFromElements(routes))
